import React from "react";
import "../../App.css";

import { BackToIndustryVerticalsButton } from "../layout/BackButton";
import QuickLinksSection from "../products/QuickLinksSection";

// Education & Research Detail Page
function EducationResearchPage({ handleNavClick }) {
  return (
    <div className="industry-detail-page edu-research-page">
      <BackToIndustryVerticalsButton handleNavClick={handleNavClick} />

      {/* Header Section */}
      <div className="edu-research-header">
        <div className="section__container">
          <h2 className="section__title">Education & Research</h2>
          <p className="section__intro">
            GEOTECH enables education and research institutes to access the technology they need to educate and inspire future generations. By providing state-of-the-art tools to curious young minds, we are investing in tomorrow's innovators to ensure business, industry, and humanity continue to sustainably thrive.
          </p>
        </div>
      </div>

      {/* About Section */}
      <section className="edu-about-section">
        <div className="section__container edu-about-container">
          <div className="edu-about-text">
            <h2>Empowering Education & Research</h2>
            <p>
              GEOTECH provides cutting-edge technology and support to educational institutions and research centers,
              empowering the next generation of innovators. We enhance learning experiences, enable impactful research,
              and equip students with the tools to shape the future.
            </p>
          </div>
          <div className="edu-about-image edu-about-image--full">
            <img src="/edu&res.jpg" alt="Education & Research Infographic" />
          </div>
        </div>
      </section>

      {/* Section 1: Supporting Industry R&D (Image Left, Text Right) */}
      <section className="edu-feature-section">
        <div className="section__container edu-feature-container">
          <div className="edu-feature-image">
            <img src="/education1.png" alt="Supporting Industry R&D" />
          </div>
          <div className="edu-feature-text">
            <h3>Supporting Industry Research & Development</h3>
            <p>
              Investing in leading research institutes and facilitating cutting-edge projects to drive innovation for a brighter tomorrow.
            </p>
          </div>
        </div>
      </section>

      {/* Section 2: Inspiring Future Talent (Text Left, Image Right) */}
      <section className="edu-feature-section reverse">
        <div className="section__container edu-feature-container">
          <div className="edu-feature-image">
            <img src="/education2.png" alt="Inspiring Future Talent" />
          </div>
          <div className="edu-feature-text">
            <h3>Inspiring Future Talent</h3>
            <p>
              Supporting educators and students with access to state-of-the-art technology, nurturing curiosity and creativity in young innovators.
            </p>
          </div>
        </div>
      </section>

      {/* Section 3: Elevating University Education (Image Left, Text Right) */}
      <section className="edu-feature-section">
        <div className="section__container edu-feature-container">
          <div className="edu-feature-image">
            <img src="/education3.png" alt="Elevating University Education" />
          </div>
          <div className="edu-feature-text">
            <h3>Elevating University Education</h3>
            <p>
              Providing students and educators with innovative tools and resources to take academic learning to new peaks.
            </p>
          </div>
        </div>
      </section>

      {/* Section 4: Research Collaboration & Innovation (Text Left, Image Right) */}
      <section className="edu-feature-section reverse">
        <div className="section__container edu-feature-container">
          <div className="edu-feature-image">
            <img src="/education4.png" alt="Research Collaboration & Innovation" />
          </div>
          <div className="edu-feature-text">
            <h3>Research Collaboration & Innovation</h3>
            <p>
              Enabling partnerships between industry and academia, fostering innovation, and driving research that shapes the future.
            </p>
          </div>
        </div>
      </section>

      {/* Quick Links Section */}
      <QuickLinksSection
        handleNavClick={handleNavClick}
        links={[
          { id: 'information-technology', title: 'Information Technology', icon: '/bgs/IT_bg.png' },
          { id: 'gis-services', title: 'GIS and Data Services', icon:'/bgs/GIS.png' },
          { id: 'environment', title: 'Environment', icon:'/bgs/env.png' },
          { id: 'health', title: 'Health', icon:'/bgs/health.png' },
          { id: 'agriculture', title: 'Agriculture', icon: '/bgs/agriculture.png' }
        ]}
      />
    </div>
  );
}

export default EducationResearchPage;
